import React from 'react';
import { SpinnerIcon } from '../../icons';

export const ConfirmationDialog = ({
  message,
  title,
  isLoading = false,
  handleOkClick,
  handleCancelClick,
  confirmCtaText='Ναι',
  cancelCtaText='Όχι'
}) => {
  return (
    <div className="lg:p-12 p-5 flex flex-col gap-5 w-full items-center lg:justify-center max-lg:h-[100vh]">
      <div className='w-full flex lg:justify-center'>
        {title && <h3 className="pb-4">{title}</h3>}
      </div>
      <div className='text-center m-auto flex items-center'>
        {message}
      </div>
      <div className="flex gap-3.5 max-lg:flex-col max-lg:flex-col-reverse max-lg:w-[90%]">
        <button
          type="button"
          className="btn-secondary text-secondary-button"
          onClick={handleCancelClick}
          disabled={isLoading}
        >
          {cancelCtaText}
        </button>
        <button
          type="button"
          disabled={isLoading}
          className="btn-primary text-primary-button flex gap-2 items-center justify-center"
          onClick={handleOkClick}
        >
          {isLoading && <SpinnerIcon />}
          {confirmCtaText}
        </button>
      </div>
    </div>
  );
};
